<template>
  <div>
    <h1 class="title">
      {{ deviceName }}-火灾报警控制器操作台({{ deviceVersion | dic("SENU095") }}
      )
    </h1>
    <div class="gts15000H-container">
      <div class="main-box column-center">
        <!-- 中 -->
        <div class="other">
          <div class="screen-box">
            {{ respondText }}
          </div>
        </div>
        <!-- 下 -->
        <div class="bottom-box">
          <!-- 键盘 -->
          <div class="keybord-box flex-between">
            <div style="display: flex; width: 365px; justify-content: space-between">
              <!-- <div class="key-btn ctl-btn bg-red" name="33" >
              <span class="text">警报器</span>
            </div> -->
              <div
                class="key-btn ctl-btn bg-red"
                name="0"
                @click="handleCheckClick('联动启动', '0')"
              >
                <span class="text">联动启动</span>
              </div>
              <div
                class="key-btn ctl-btn bg-green"
                name="1"
                @click="handleCheckClick('复位', '1')"
              >
                <span class="text">复位</span>
              </div>
              <div
                class="key-btn ctl-btn bg-gray"
                name="2"
                @click="handleCheckClick('消音', '2')"
              >
                <span class="text">消音</span>
              </div>
            </div>

            <div
              v-for="(items, indexs) in keyBordList"
              :key="indexs"
              :name="items.value"
              class="key-btn ctl-btn"
              @click="handleCheckClick(items.num+'/'+items.text, items.value)"
            >
              <span class="num-span" style="height: 20px; line-height: 20px"
                >{{ items.num }}
                <i
                  v-if="items.value == '39'"
                  style="font-size: 12px"
                  class="icon iconfont-lunan icon-lunan-kongge"
                ></i>
                <i
                  v-if="items.value == '19'"
                  style="margin-left: 5px; font-size: 12px"
                  class="el-icon-minus"
                ></i>
              </span>

              <span class="text-span" v-if="items.text">{{ items.text }}</span>
            </div>
          </div>
          <div class="middle-btns">
            <!-- 控制手柄 -->
            <ul class="cloud-handel">
              <li
                class="right direction ctl-btn"
                name="5"
                @click="handleCheckClick('上', 5)"
              ></li>
              <li
                class="top direction ctl-btn"
                name="7"
                @click="handleCheckClick('左', 7)"
              ></li>
              <li
                class="right direction ctl-btn"
                name="6"
                @click="handleCheckClick('下', 6)"
              ></li>
              <li
                class="top direction ctl-btn"
                name="8"
                @click="handleCheckClick('右', 8)"
              ></li>
            </ul>
            <div class="circle-btn ctl-btn" name="40" @click="handleCheckClick('？', 40)">
              <div class="inside-circle">?</div>
            </div>
            <!-- 确认取消按钮 -->
            <div
              class="confirm-btn ctl-btn"
              name="3"
              @click="handleCheckClick('确认', 3)"
            >
              确认
            </div>
            <div
              class="cancle-btn ctl-btn"
              style="color: red"
              name="4"
              @click="handleCheckClick('取消', 4)"
            >
              取消
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mixin from "./minx";
import { Dic } from "$utils";
export default {
  mixins: [mixin],
  props: {
    deviceName: {
      type: String,
      default: () => {
        return "";
      },
    },
    deviceVersion: {
      type: String,
      default: () => {
        return "";
      },
    },
  },
  data() {
    return {
      btnClass: {
        0: "red",
        1: "green",
        2: "gray",
      },
      keyBordList: [
        {
          num: "+ 1",
          text: "自检",
          value: "10",
        },
        {
          num: "xabc 2",
          text: "查询",
          value: "11",
        },
        {
          num: "=def 3",
          text: "用户设置",
          value: "12",
        },
        {
          num: "*",
          text: "",
          value: "19",
        },
        {
          num: "ghi 4",
          text: "启动",
          value: "13",
        },
        {
          num: "jkl 5",
          text: "屏蔽",
          value: "14",
        },
        {
          num: "mno 6",
          text: "系统设置",
          value: "15",
        },
        {
          num: "0",
          text: "",
          value: "9",
        },
        {
          num: "pqrs 7",
          text: "停动",
          value: "16",
        },
        {
          num: "tuv 8",
          text: "取消屏蔽",
          value: "17",
        },
        {
          num: "wxyz 9",
          text: "打印设置",
          value: "18",
        },
        {
          num: "&",
          text: "",
          value: "39",
        },
      ],
    };
  },
  mounted() {},
  methods: {
    changeBgColor(isSuccess, btnListCode) {
      // console.log(isSuccess, btnListCode);
      // btnListCode.forEach((item) => {
      //   let divItem = document.getElementsByName(item);
      //   divItem.forEach((data) => {
      //     if (isSuccess) data.classList.add("greenBg");
      //     else data.classList.add("redBg");
      //   });
      // });
    },
  },
};
</script>
<style lang="scss" scoped>
.bg-red {
  background: rgba(125, 16, 20, 1) !important;
  border: 1px solid rgba(125, 16, 20, 1);
}
.bg-green {
  background: rgba(0, 178, 115, 1) !important;
  border: 1px solid rgba(0, 178, 115, 1);
}
.bg-gray {
  background: rgba(84, 83, 80, 1) !important;
}
.redBg {
  background: red !important;
  color: #fff !important;
}
.greenBg {
  background: green !important;
}
.middle-btns {
  width: 30%;
  height: 50%;
  position: relative;
  .circle-btn {
    width: 56px;
    height: 56px;
    border: 1px solid #404040;
    background: linear-gradient(180deg, #00c780 0%, #006440 100%);
    border-radius: 50%;
    opacity: 1;
    position: absolute;
    left: 90px;
    top: 42px;
    .inside-circle {
      text-align: center;
      width: 50px;
      height: 50px;
      line-height: 50px;
      background: linear-gradient(360deg, #00c780 0%, #006440 100%);
      border-radius: 50%;
      margin: 1px auto;
    }
  }

  .confirm-btn {
    text-align: center;
    width: 60px;
    height: 35px;
    line-height: 35px;
    background-image: url("./img/btnleft-default.png");
    background-size: 100% 100%;
    position: absolute;
    left: 25px;
    bottom: -75px;
    cursor: pointer;
    &:hover {
      background-image: url("./img/btnleft-hover.png");
    }
  }
  .cancle-btn {
    text-align: center;
    width: 60px;
    height: 35px;
    line-height: 35px;
    background-image: url("./img/btnright-default.png");
    background-size: 100% 100%;
    position: absolute;
    right: -35px;
    bottom: -75px;
    cursor: pointer;
    &:hover {
      background-image: url("./img/btnright-hover.png");
    }
  }
  .cloud-handel {
    list-style: none;
    margin: 0;
    padding: 0;
    height: 100%;
    left: 200px;
    top: -8px;
    position: absolute;

    .top {
      top: 55px;
    }

    .right {
      right: 43px;
    }

    li {
      cursor: pointer;
      position: absolute;
      background-image: url("./img/btn-default.png");
      height: 40px;
      width: 80px;
      background-size: 100% 100%;

      &:hover {
        background-image: url("./img/btn-hover.png");
      }

      &:first-child {
        top: 10px;
      }

      &:nth-child(2) {
        right: 97px;
        transform: rotate(-90deg);
      }

      &:nth-child(3) {
        top: 105px;
        transform: rotate(-180deg);
      }

      &:last-child {
        right: -11px;
        transform: rotate(90deg);
      }
    }
  }
}
@import "~@src/common/assets/style/mixin";
.title {
  font-size: 18px;
  margin-bottom: 10px;
  text-align: center;
  line-height: 20px;
}
.gts15000H-container {
  width: 100%;
  height: 58vh;
  background: #a9aaa4;
  opacity: 1;
  border-radius: 30px;
  padding: 10px;
  .ctl-btn {
    &:hover {
      opacity: 0.6 !important;
      cursor: pointer;
    }
  }
  .lh40 {
    line-height: 40px;
  }
  .lh18 {
    line-height: 18px;
  }
  .red {
    background: linear-gradient(180deg, #ff0000 0%, #800000 100%);
  }
  .green {
    background: linear-gradient(180deg, #00ce6f 0%, #006738 100%);
  }
  .gray {
    background: linear-gradient(180deg, #eeeeee 0%, #a1a1a1 100%);
  }
  .blue {
    background: #2fbbeb;
  }
  .pink {
    background: #f56285;
  }
  .main-box {
    width: 100%;
    height: 100%;
    background: #8c9492;
    border: 1px solid #707070;
    opacity: 1;
    border-radius: 20px;
    padding: 10px 50px;
    align-items: center;
    .top-box {
      width: 100%;
      height: 40%;
      flex-wrap: wrap;
      padding: 2% 0;
      box-sizing: border-box;
      .light-item {
        width: 100px;
        height: 35px;
        border: 1px solid #404040;
        opacity: 1;
        border-radius: 6px;
        margin-bottom: 4px;
        .light {
          width: 100%;
          height: 100%;
          text-align: left;
          padding: 0px 5px;
          display: flex;
          flex-direction: row;
          align-items: center;
          span {
            display: inline-block;
            width: 60px;
            margin-right: 5px;
          }
          .point {
            display: inline-block;
            width: 10px;
            height: 10px;
            border-radius: 50px;
            box-shadow: 0px 0px 0px 3px #fff;
            -webkit-box-shadow: 0px 0px 0px 3px #fff;
            -moz-box-shadow: #fff 0px 0px 3px;
          }
          .name {
            margin-left: 5px;
          }
        }
      }
    }
    .other {
      width: 582px;
      height: 35%;
      background: #000000;
      border: 1px solid #ffffff;
      opacity: 1;
      border-radius: 15px;
      padding: 6px;
      .screen-box {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        background: #adbfb2;
        border: 1px solid #555a56;
        opacity: 1;
        border-radius: 10px;
      }
    }
    .middle-box {
      width: 438px;
      height: 20%;
      background: #646464;
      border: 1px solid #898989;
      opacity: 1;
      border-radius: 18px;
      padding-top: 15px;
      box-sizing: border-box;
      // margin-top: 10px;
      .top {
        width: 100%;
        height: 85%;
        .screen {
          width: 147px;
          height: 100%;
          background: #000000;
          border: 1px solid #ffffff;
          opacity: 1;
          border-radius: 15px;
          padding: 4px;
          &:nth-child(1) {
            margin-left: 30px;
          }
          .inside-screen {
            width: 139px;
            font-size: 37px;
            line-height: 55px;
            height: 100%;
            background: #adbfb2;
            border: 1px solid #555a56;
            opacity: 1;
            border-radius: 12px;
            text-align: center;
          }
        }
        .yuan {
          width: 40px;
          height: 100%;
          align-items: center;
          .doit {
            width: 14px;
            height: 14px;
            background: #ffffff;
            border: 1px solid #707070;
            border-radius: 50%;
            opacity: 1;
            &:nth-child(1) {
              margin-bottom: 20px;
            }
          }
        }
      }

      .text {
        letter-spacing: 20px;
        font-size: 18px;
        padding-left: 20px;
      }
    }
    .bottom-box {
      width: 100%;
      height: 43%;
      display: flex;
      margin-top: 10px;
      padding-top: 15px;
      .top-btns {
        height: 25%;
        .fire-btn {
          width: 104px;
          height: 40px;
          border: 1px solid #292929;
          background: linear-gradient(180deg, #ff534b 0%, #802a26 100%);
          opacity: 1;
          border-radius: 20px;
          text-align: center;
        }
      }
      .keybord-box {
        height: 105%;
        width: 66%;
        flex-wrap: wrap;
        .key-btn {
          text-align: center;
          width: 75px;
          height: 40px;
          // border: 1px solid #404040;
          background: linear-gradient(180deg, #767676 0%, #262626 100%);
          opacity: 1;
          border-radius: 18px;
          margin-bottom: 5px;
          margin-right: 10px;
          font-size: 12px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          // &:nth-child(5) {
          //   line-height: 30px;
          // }
          // &:nth-child(10) {
          //   line-height: 30px;
          // }
          // &:nth-child(15) {
          //   line-height: 30px;
          // }
          // &:nth-child(20) {
          //   line-height: 30px;
          // }
          span {
            display: block;
          }
          .text {
            height: 40px;
            line-height: 40px;
          }
        }
      }
    }
  }
}
</style>
